import { gql } from 'apollo-angular';

export const categorySelectOptionsQuery = gql`
  query CategorySelectOptions($includeGateway: Boolean, $widgetType: String) {
    categoryList(includeGateway: $includeGateway, widgetType: $widgetType) {
      id
      name
    }
  }
`;
